const de = require("./language_json/de.json");

export default de;
